module.exports = __webpack_public_path__ + "static/media/Helius Composite.77e766fa.png";